import { CommonEnums } from '../../common.enums';

export class DObj_Inst_Property {
	dxFlow_Id: number;
	property_Id: number;
	dxMp_Inst_Id: number;
	obj_Id: number;
	obj_Cd: string;
	propertyType: string;
	propertyNm: string;
	propertyVal: string;
	dbTyp_Id: number;
	srt_Order: number;
	defView: string;

	constructor() {
		this.setDefault();
	}

	setDefault(): void {
		this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
		this.property_Id = CommonEnums.defaults.LONG_VAL;
		this.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
		this.obj_Id = CommonEnums.defaults.LONG_VAL;
		this.propertyType = CommonEnums.defaults.STRING_EMPTY;
		this.propertyNm = CommonEnums.defaults.STRING_EMPTY;
		this.propertyVal = CommonEnums.defaults.STRING_EMPTY;
		this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
		this.srt_Order = CommonEnums.defaults.LONG_VAL;
		this.defView = CommonEnums.defaults.STRING_EMPTY;
		this.obj_Cd=CommonEnums.defaults.STRING_EMPTY;
	}

	static parse(dObj_Inst_PropertyTmp: any): DObj_Inst_Property {
		let dObj_Inst_Property: DObj_Inst_Property = new DObj_Inst_Property();
		dObj_Inst_Property.copyFrom(dObj_Inst_PropertyTmp as DObj_Inst_Property);
		return dObj_Inst_Property;
	}

	getPrimaryKey(): string {
		return this.dxFlow_Id + '.' + this.dxMp_Inst_Id + '.' + this.obj_Id + '.' + this.dbTyp_Id + '.' + this.property_Id + '.' + this.propertyNm
			+ this.propertyType;
	}
	
	copy(): DObj_Inst_Property {
		let dObj_Inst_PropertyTmp: DObj_Inst_Property = new DObj_Inst_Property();

		dObj_Inst_PropertyTmp.dxFlow_Id = this.dxFlow_Id;
		dObj_Inst_PropertyTmp.property_Id = this.property_Id;
		dObj_Inst_PropertyTmp.dxMp_Inst_Id = this.dxMp_Inst_Id;
		dObj_Inst_PropertyTmp.obj_Id = this.obj_Id;
		dObj_Inst_PropertyTmp.propertyType = this.propertyType;
		dObj_Inst_PropertyTmp.propertyNm = this.propertyNm;
		dObj_Inst_PropertyTmp.propertyVal = this.propertyVal;
		dObj_Inst_PropertyTmp.dbTyp_Id = this.dbTyp_Id;
		dObj_Inst_PropertyTmp.srt_Order = this.srt_Order;
		dObj_Inst_PropertyTmp.defView = this.defView;
		dObj_Inst_PropertyTmp.obj_Cd= this.obj_Cd;
		return dObj_Inst_PropertyTmp;
	}

	copyFrom(dObj_Inst_PropertyTmp: DObj_Inst_Property): void {
		this.dxFlow_Id = dObj_Inst_PropertyTmp.dxFlow_Id;
		this.property_Id = dObj_Inst_PropertyTmp.property_Id;
		this.dxMp_Inst_Id = dObj_Inst_PropertyTmp.dxMp_Inst_Id;
		this.obj_Id = dObj_Inst_PropertyTmp.obj_Id;
		this.propertyType = dObj_Inst_PropertyTmp.propertyType;
		this.propertyNm = dObj_Inst_PropertyTmp.propertyNm;
		this.propertyVal = dObj_Inst_PropertyTmp.propertyVal;
		this.dbTyp_Id = dObj_Inst_PropertyTmp.dbTyp_Id;
		this.srt_Order = dObj_Inst_PropertyTmp.srt_Order;
		this.defView = dObj_Inst_PropertyTmp.defView;
		this.obj_Cd=dObj_Inst_PropertyTmp.obj_Cd;
	}

	compare(dObj_Inst_PropertyTmp: DObj_Inst_Property): string {
		let dObj_Inst_PropertyString: string = this.toString(false);
		let dObj_Inst_PropertyTmpString: string = dObj_Inst_PropertyTmp.toString(false);

		if (dObj_Inst_PropertyString != dObj_Inst_PropertyTmpString) {
			return dObj_Inst_PropertyString + ', ' + dObj_Inst_PropertyTmpString;
		}
		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "DObj_Inst_Property [dxFlow_Id=" + this.dxFlow_Id +
			", property_Id=" + this.property_Id +
			", dxMp_Inst_Id=" + this.dxMp_Inst_Id +
			", obj_Id=" + this.obj_Id +
			", propertyType=" + this.propertyType +
			", propertyNm=" + this.propertyNm +
			", propertyVal=" + this.propertyVal +
			", srt_Order=" + this.srt_Order +
			", defView=" + this.defView+
			",obj_Cd ="+ this.obj_Cd; 
			
		if (isNotCompare) {
			str += ''
		}

		str += ']';

		return str;
	}
}